<template>
  <div class="container">
    <img src="../../assets/images/404.png" />
  </div>
</template>

<script>
export default {
  name: "Mine",
  data() {
    return {};
  },
  components: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
